import { Layout } from 'antd';
import React from 'react';
import CreateProjectForm from '../../component/CreateProjectForm/CreateProjectForm';
import AppHeader from '../../../../components/AppHeader';
import { Product } from '../../../../../data/terra/Product';

interface CreateProjectContentProps {
  onCreateProjectSuccess: (project: Product) => void;
}

const CreateProjectContent: React.FC<CreateProjectContentProps> = ({
  onCreateProjectSuccess,
}) => {
  return (
    <Layout
      className="create-project-app-layout-v2"
      style={{ background: '#f5f6fc' }}
    >
      <AppHeader />
      <div className="app-header-placeholder-v2" />
      <CreateProjectForm onCreateProjectSuccess={onCreateProjectSuccess} />
    </Layout>
  );
};

export default CreateProjectContent;
